import { COMPANY_TYPE_INFOS } from '@sr/dto';

type TypeInfo = {
  value: string;
  label: string;
};

export const getCompanyTypeArray = ({
  isClient,
  isSupplier,
  isMedia,
  isCompetitor,
}: {
  isClient: boolean;
  isSupplier: boolean;
  isMedia: boolean;
  isCompetitor: boolean;
}): TypeInfo[] => {
  const result: TypeInfo[] = [];

  if (isClient) result.push(COMPANY_TYPE_INFOS.client);
  if (isSupplier) result.push(COMPANY_TYPE_INFOS.supplier);
  if (isMedia) result.push(COMPANY_TYPE_INFOS.media);
  if (isCompetitor) result.push(COMPANY_TYPE_INFOS.competitor);

  return result;
};